export default __webpack_public_path__ + "static/media/contactsPurple.eeaa4ce4.svg";